import type { Capability } from 'owa-capabilities';
import type { MailboxInfo } from 'owa-client-types';
/* eslint-disable-next-line @typescript-eslint/no-restricted-imports -- (https://aka.ms/OWALintWiki)
 * Existing isFeatureEnabled usage — migrate to isGlobalFeatureEnabled or isAccountFeatureEnabled
 *	> 'isFeatureEnabled' import from 'owa-feature-flags' is restricted. Use isGlobalFeatureEnabled or isAccountFeatureEnabled from owa-feature-flags instead */
import { isFeatureEnabled } from 'owa-feature-flags';
import { isAnalyzeContentDisabledForPrivacy } from 'owa-privacy-utils/lib/selectors/isAnalyzeContentDisabledForPrivacy';
import { isServiceRequestSupportedForMailbox } from 'owa-service/lib/utils/isServiceRequestSupportedForMailbox';

/**
 * NOTE: Please see the README for more information on how the
 * capability functions must be implemented and used.
 */
export const translatorCapability: Capability = {
    isEnabled: (mailboxInfo?: MailboxInfo) => {
        /* eslint-disable-next-line owa-custom-rules/require-undefined-parameter -- (https://aka.ms/OWALintWiki)
         * Flight checks that supply MailboxInfo should be defined as AccountFeatureName value and should be checked using isAccountFeatureEnabled to ensure consistent checking.
         *	> The parameter mailboxInfo must be undefined. Feature flight: 'rp-inlineTranslation' */
        return isFeatureEnabled('rp-inlineTranslation', mailboxInfo);
    },
    isSupported: (mailboxInfo?: MailboxInfo) => {
        return (
            !isAnalyzeContentDisabledForPrivacy() &&
            isServiceRequestSupportedForMailbox(mailboxInfo)
        );
    },
};
